import {createSelector} from "reselect";

const getNotificationState = (state) => state.dmNotifications;

export const getUnreadDMNotificationCount = createSelector([ getNotificationState ], ({ unreadDMNotificationCount }) => unreadDMNotificationCount);